import script from "./AssetRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetRegistration.vue?vue&type=script&setup=true&lang=js"

import "./AssetRegistration.vue?vue&type=style&index=0&id=6504257a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6504257a"]])

export default __exports__